import { EditorState } from 'prosemirror-state';
import { tableNodes } from 'prosemirror-tables';
import { findParentNode } from 'prosemirror-utils';

import { tableCellContent } from '../../../consts/nodes';

type TableNodeType = 'table' | 'table_row' | 'table_cell' | 'table_header';

export const getTableNode = (tableNodeType: TableNodeType) =>
  tableNodes({
    tableGroup: 'block',
    cellContent: tableCellContent,
    cellAttributes: {},
  })[tableNodeType];

export const getTable = (state: EditorState) =>
  findParentNode((node) => {
    return node.type.name === 'table';
  })(state.selection);
